window.CF = window.CF || {};

(function (CF) {
  'use strict';

  CF.initMarquee = function (track) {
    if (!track || track.dataset.cfMarqueeReady === 'true') return;

    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;

    items.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    track.dataset.cfMarqueeReady = 'true';
  };

  CF.initMarquees = function (root) {
    var scope = root || document;
    scope.querySelectorAll('.cf-marquee__track').forEach(CF.initMarquee);
  };

  CF.cartPopupDuration = 8000;

  var cartPopupTimer = null;

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function showCartPopup() {
    var popup = document.getElementById('js--cart-popup');

    if (!popup || typeof window.renderCartSummary !== 'function') {
      return fetch(cartRoot() + 'cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          document.querySelectorAll('.js--cart-counter').forEach(function (el) {
            el.innerText = cart.item_count;
          });
        });
    }

    return window.renderCartSummary(true).then(function () {
      popup.open = true;

      window.clearTimeout(cartPopupTimer);
      cartPopupTimer = window.setTimeout(function () {
        popup.open = false;
        var notice = popup.querySelector('#cart-popup-summary_notification');
        if (notice) notice.remove();
      }, CF.cartPopupDuration);
    });
  }

  function onAddToCart(event) {
    var btn = event.currentTarget;
    var form = btn.closest('form');
    if (!form) return;

    var variant = form.querySelector('input[name="id"]');
    if (!variant || !window.fetch) return;

    event.preventDefault();

    var quantityInput = form.querySelector('input[name="quantity"]');
    var quantity = parseInt(quantityInput ? quantityInput.value : '1', 10) || 1;

    var label = btn.innerHTML;
    btn.innerHTML = '<span class="cf-pcard__spinner" role="status" aria-label="Adding to cart"></span>';
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    function restore() {
      btn.innerHTML = label;
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }

    fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variant.value, quantity: quantity }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add.js returned ' + response.status);
        return response.json();
      })
      .then(showCartPopup)
      .then(restore)
      .catch(function () {
        restore();
        form.submit();
      });
  }

  CF.initAddToCart = function (root) {
    var scope = root || document;
    scope.querySelectorAll('.cf-atc').forEach(function (btn) {
      if (btn.dataset.cfAtcReady === 'true') return;
      btn.dataset.cfAtcReady = 'true';
      btn.addEventListener('click', onAddToCart);
    });
  };

  function carouselStep(track) {
    var card = track.firstElementChild;
    if (!card) return track.clientWidth;

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;

    return card.getBoundingClientRect().width + gap;
  }

  function syncCarousel(track, prev, next) {
    var max = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= max - 1;

    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  CF.initCarousel = function (root) {
    if (!root || root.dataset.cfCarouselReady === 'true') return;

    var track = root.querySelector('[data-cf-carousel-track]');
    if (!track) return;

    root.dataset.cfCarouselReady = 'true';

    var prev = root.querySelector('[data-cf-carousel-prev]');
    var next = root.querySelector('[data-cf-carousel-next]');

    function scrollBy(direction) {
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({
        left: carouselStep(track) * direction,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    var syncing = false;
    function queueSync() {
      if (syncing) return;
      syncing = true;
      window.requestAnimationFrame(function () {
        syncing = false;
        syncCarousel(track, prev, next);
      });
    }

    track.addEventListener('scroll', queueSync, { passive: true });
    window.addEventListener('resize', queueSync);

    window.addEventListener('load', queueSync);

    syncCarousel(track, prev, next);
  };

  CF.initCarousels = function (root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cf-carousel]').forEach(CF.initCarousel);
  };

  CF.initSortForms = function (root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cf-sort]').forEach(function (form) {
      if (form.dataset.cfSortReady === 'true') return;
      form.dataset.cfSortReady = 'true';

      var select = form.querySelector('select[name="sort_by"]');
      if (!select) return;

      select.addEventListener('change', function () {
        form.submit();
      });
    });
  };

  function openDrawer(state) {
    if (state.open) return;
    state.open = true;
    state.opener = document.activeElement;

    state.panel.hidden = false;
    if (state.backdrop) state.backdrop.hidden = false;
    document.body.classList.add('cf-drawer-open');

    window.requestAnimationFrame(function () {
      state.panel.classList.add('is-open');
      if (state.backdrop) state.backdrop.classList.add('is-open');
    });

    state.buttons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    var focusable = state.panel.querySelector('button, [href], input, select, summary');
    if (focusable) focusable.focus();
  }

  function closeDrawer(state) {
    if (!state.open) return;
    state.open = false;

    state.panel.classList.remove('is-open');
    if (state.backdrop) state.backdrop.classList.remove('is-open');
    document.body.classList.remove('cf-drawer-open');

    state.buttons.forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    if (state.opener && document.contains(state.opener)) state.opener.focus();

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hide = function () {
      if (state.open) return;
      state.panel.hidden = true;
      if (state.backdrop) state.backdrop.hidden = true;
    };

    if (reduced) hide();
    else window.setTimeout(hide, 300);
  }

  CF.initFilterDrawer = function (root) {
    var scope = root || document;
    var panel = scope.querySelector('#collection-filters');
    if (!panel || panel.dataset.cfDrawerReady === 'true') return;

    var buttons = Array.prototype.slice.call(document.querySelectorAll('[data-cf-filter-open]'));
    if (!buttons.length) return;

    panel.dataset.cfDrawerReady = 'true';

    var state = {
      panel: panel,
      backdrop: document.querySelector('.cf-drawer__backdrop'),
      buttons: buttons,
      open: false,
      opener: null
    };

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.open) closeDrawer(state);
        else openDrawer(state);
      });
    });

    document.querySelectorAll('[data-cf-filter-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closeDrawer(state);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && state.open) closeDrawer(state);
    });
  };

  var RECENT_KEY = 'recentlyViewed';
  var RECENT_MAX = 8;

  function readRecent() {
    var raw;
    try {
      raw = window.localStorage.getItem(RECENT_KEY);
    } catch (error) {
      return [];
    }
    if (!raw) return [];

    var items;
    try {
      items = JSON.parse(raw);
    } catch (error) {
      return [];
    }
    if (!Array.isArray(items)) return [];

    return items
      .filter(function (item) {
        return item && typeof item.handle === 'string' && item.handle;
      })
      .sort(function (a, b) {
        return (b.date || 0) - (a.date || 0);
      });
  }

  function writeRecent(items) {
    try {
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(items.slice(0, RECENT_MAX)));
    } catch (error) {
    }
  }

  function rememberProduct(handle) {
    var items = readRecent().filter(function (item) {
      return item.handle !== handle;
    });
    items.unshift({ handle: handle, date: Date.now() });
    writeRecent(items);
  }

  function forgetProduct(handle) {
    writeRecent(readRecent().filter(function (item) {
      return item.handle !== handle;
    }));
  }

  function fetchCard(handle) {
    return window
      .fetch('/products/' + encodeURIComponent(handle) + '?view=card', {
        method: 'GET',
        redirect: 'error'
      })
      .then(function (response) {
        if (!response.ok) {
          forgetProduct(handle);
          return '';
        }
        return response.text();
      })
      .catch(function () {
        forgetProduct(handle);
        return '';
      });
  }

  function fillRecentRow(section) {
    var grid = section.querySelector('[data-cf-recent-grid]');
    if (!grid) return;

    var limit = parseInt(section.getAttribute('data-cf-recent-limit'), 10);
    if (!limit || limit < 1) limit = 4;

    var current = section.getAttribute('data-cf-recent-save');

    var handles = readRecent()
      .map(function (item) {
        return item.handle;
      })
      .filter(function (handle) {
        return handle !== current;
      })
      .slice(0, limit);

    if (!handles.length) return;

    Promise.all(handles.map(fetchCard)).then(function (cards) {
      var markup = cards
        .filter(function (card) {
          return card;
        })
        .join('');

      if (!markup) return;

      grid.insertAdjacentHTML('beforeend', markup);
      CF.initAddToCart(grid);
      section.hidden = false;
    });
  }

  CF.initRecentlyViewed = function (root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-cf-recent]');

    sections.forEach(function (section) {
      if (section.dataset.cfRecentReady === 'true') return;
      section.dataset.cfRecentReady = 'true';

      fillRecentRow(section);

      var handle = section.getAttribute('data-cf-recent-save');
      if (handle) rememberProduct(handle);
    });
  };

  function fillRecsRow(section) {
    var grid = section.querySelector('[data-cf-recs-grid]');
    var sectionId = section.getAttribute('data-cf-recs-id');
    var productId = section.getAttribute('data-cf-recs-product');
    if (!grid || !sectionId || !productId) return;

    var limit = parseInt(section.getAttribute('data-cf-recs-limit'), 10);
    if (!limit || limit < 1) limit = 4;

    var url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/') + 'recommendations/products' +
      '?section_id=' + encodeURIComponent(sectionId) +
      '&product_id=' + encodeURIComponent(productId) +
      '&limit=' + limit;

    window
      .fetch(url, { method: 'GET' })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (html) {
        if (!html) return;

        var fetched = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-cf-recs-grid]');

        if (!fetched || !fetched.children.length) return;

        grid.innerHTML = fetched.innerHTML;
        CF.initAddToCart(grid);
        section.hidden = false;
      })
      .catch(function () {
      });
  }

  CF.initRecommendations = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-cf-recs]').forEach(function (section) {
      if (section.dataset.cfRecsReady === 'true') return;
      section.dataset.cfRecsReady = 'true';
      fillRecsRow(section);
    });
  };

  function galleryImages(gallery) {
    return gallery.querySelectorAll('.cf-gal__stage .cf-gal__img');
  }

  CF.showProductImage = function (gallery, index) {
    if (!gallery) return;

    var images = galleryImages(gallery);
    if (!images.length) return;
    if (index < 0 || index >= images.length) return;

    images.forEach(function (img, i) {
      img.hidden = i !== index;
    });

    gallery.querySelectorAll('.cf-gal__thumb').forEach(function (thumb, i) {
      var on = i === index;
      thumb.classList.toggle('is-active', on);
      thumb.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  function warmProductImage(gallery, index) {
    var img = galleryImages(gallery)[index];
    if (!img || img.dataset.cfWarm === 'true') return;

    img.dataset.cfWarm = 'true';
    img.loading = 'eager';
    new window.Image().src = img.src;
  }

  function thumbIndex(event, gallery) {
    var thumb = event.target.closest ? event.target.closest('.cf-gal__thumb') : null;
    if (!thumb || !gallery.contains(thumb)) return -1;

    var index = parseInt(thumb.getAttribute('data-cf-gal-thumb'), 10);
    return isNaN(index) ? -1 : index;
  }

  CF.initProductGallery = function (root) {
    var scope = root || document;

    scope.querySelectorAll('[data-cf-gallery]').forEach(function (gallery) {
      if (gallery.dataset.cfGalleryReady === 'true') return;
      gallery.dataset.cfGalleryReady = 'true';

      ['mouseover', 'focusin', 'touchstart'].forEach(function (type) {
        gallery.addEventListener(type, function (event) {
          var index = thumbIndex(event, gallery);
          if (index > -1) warmProductImage(gallery, index);
        }, { passive: true });
      });

      gallery.addEventListener('click', function (event) {
        var index = thumbIndex(event, gallery);
        if (index < 0) return;

        CF.showProductImage(gallery, index);
      });
    });
  };

  if (typeof window.goToImage !== 'function') {
    window.goToImage = function (index, container) {
      var gallery = (container && container.closest)
        ? container.closest('[data-cf-gallery]')
        : document.querySelector('[data-cf-gallery]');

      if (!gallery) return;

      CF.showProductImage(gallery, parseInt(index, 10));
    };
  }

  var STICKY_GAP_FALLBACK = 32;
  var stickyFrame = 0;
  var stickyObserver = null;

  function stickyHeaderBottom() {
    var bottom = 0;

    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (section) {
      var style = window.getComputedStyle(section);
      if (style.position !== 'sticky' && style.position !== 'fixed') return;

      var height = section.offsetHeight;
      if (!height) return;

      bottom = Math.max(bottom, (parseFloat(style.top) || 0) + height);
    });

    return bottom;
  }

  function syncStickyOffset() {
    stickyFrame = 0;

    // The header and nav stick below the announcement bar (custom.css). Not
    // offsetHeight: the bar is 36.5px and rounding leaves a half-pixel seam.
    var announcement = document.querySelector('.announcement-bar-section');
    document.documentElement.style.setProperty('--cf-announce-h', (announcement ? announcement.getBoundingClientRect().height : 0) + 'px');

    var top = stickyHeaderBottom();
    document.documentElement.style.setProperty('--cf-sticky-top', top + 'px');

    document.querySelectorAll('[data-cf-gal-sticky]').forEach(function (gallery) {
      var gap = parseFloat(window.getComputedStyle(gallery).getPropertyValue('--gal-sticky-gap'));
      if (isNaN(gap)) gap = STICKY_GAP_FALLBACK;

      var fits = top + gap + gallery.offsetHeight <= window.innerHeight;
      gallery.setAttribute('data-cf-gal-sticky', fits ? 'on' : 'off');
    });
  }

  function queueStickyOffset() {
    if (!stickyFrame) stickyFrame = window.requestAnimationFrame(syncStickyOffset);
  }

  CF.initStickyOffset = function () {
    if (!stickyObserver) {
      window.addEventListener('resize', queueStickyOffset);
      if ('ResizeObserver' in window) stickyObserver = new window.ResizeObserver(queueStickyOffset);
    }

    if (stickyObserver) {
      document.querySelectorAll('.shopify-section-group-header-group, [data-cf-gal-sticky]').forEach(function (el) {
        if (el.dataset.cfStickyWatched === 'true') return;
        el.dataset.cfStickyWatched = 'true';
        stickyObserver.observe(el);
      });
    }

    queueStickyOffset();
  };

  function findVariant(id) {
    if (typeof window.variants === 'undefined' || !window.variants) return null;

    for (var i = 0; i < window.variants.length; i++) {
      if (String(window.variants[i].id) === String(id)) return window.variants[i];
    }
    return null;
  }

  function money(cents) {
    var out = (window.Shopify && typeof window.Shopify.formatMoney === 'function')
      ? window.Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);

    return cents % 100 === 0 ? out.replace(/[.,]00(?!\d)/, '') : out;
  }

  CF.refreshBuyBox = function (root) {
    var scope = root || document;

    var idField = scope.querySelector('input#js--variant-id');
    if (!idField) return;

    var variant = findVariant(idField.value);
    if (!variant) return;

    var saving = 0;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      saving = variant.compare_at_price - variant.price;
    }

    var now = scope.querySelector('.js--variant-price');
    if (now) now.textContent = money(variant.price);

    var was = scope.querySelector('.js--variant-compareatprice');
    if (was) was.textContent = saving > 0 ? money(variant.compare_at_price) : '';

    var pill = scope.querySelector('[data-cf-save]');
    if (pill) {
      pill.hidden = saving <= 0;
      if (saving > 0) {
        pill.textContent = (pill.getAttribute('data-prefix') || '') + ' ' + money(saving);
      }
    }

    var stock = scope.querySelector('[data-cf-stock]');
    if (stock) {
      var text = stock.querySelector('.cf-buy__stock-text');
      stock.classList.toggle('is-out', !variant.available);
      if (text) {
        text.textContent = variant.available
          ? stock.getAttribute('data-in')
          : stock.getAttribute('data-out');
      }
    }

    repairAtc(scope.querySelector('#js--addtocart'), variant.available
      ? 'data-label-available'
      : 'data-label-soldout');
  };

  function repairAtc(atc, labelAttr) {
    if (!atc) return;

    var label = labelAttr ? atc.getAttribute(labelAttr) : null;

    if (atc.querySelector('.cf-buy__atc-label') === null) {
      var kept = (atc.textContent || '').trim();
      atc.innerHTML = (atc.getAttribute('data-icon') || '') +
        '<span class="cf-buy__atc-label"></span>';
      atc.querySelector('.cf-buy__atc-label').textContent = label || kept;
      return;
    }

    if (label) atc.querySelector('.cf-buy__atc-label').textContent = label;
  }

  CF.initBuyBox = function (root) {
    var scope = root || document;

    var form = scope.querySelector('.cf-buy__form');
    if (!form || form.dataset.cfBuyReady === 'true') return;
    form.dataset.cfBuyReady = 'true';

    var atc = form.querySelector('#js--addtocart');
    var icon = atc && atc.querySelector('svg');
    if (atc && icon) atc.setAttribute('data-icon', icon.outerHTML);

    form.querySelectorAll('.js--variant-option').forEach(function (input) {
      input.addEventListener('change', function () {
        window.setTimeout(function () { CF.refreshBuyBox(form); }, 0);
      });
    });

    form.addEventListener('change', function (event) {
      if (!event.target.classList.contains('js--package-addon-input')) return;
      window.setTimeout(function () { repairAtc(atc); }, 0);
    });
  };


  /* === FB5 + FB7 · Mega menu ===============================================
     Two problems, one owner.

     FB5: the theme builds every parent menu as <details><summary>, which is
     click-only. The design opens on hover.

     FB7: theme.js is read-only, and its `toggle` listener closes the sibling
     <details> from inside the handler. <details> queues `toggle` asynchronously
     and coalesces it, so clicking two headers in quick succession made a stale
     handler close the panel the visitor had just asked for — the client's
     "crash the menu loader". Above 1100px we take the click over so the browser
     never toggles behind our back, and every open goes through openOnly(),
     which closes the others *first*: by the time theme.js's handler runs there
     is nothing left for it to close, so it cannot start a second round.

     It also only ever binds on a page loaded wider than 1100px. Everything here
     reads the media query at event time instead, so a resize is enough.
     ======================================================================== */

  CF.megaMenuOpenDelay = 120;
  CF.megaMenuCloseDelay = 200;
  // FB10: breathing room under a panel that had to be cut to fit, and a floor
  // so a freak measurement — a header caught mid-resize, a window shorter than
  // the bar itself — cannot collapse the panel to nothing. The floor is not a
  // comfortable height on purpose: anything above the room actually available
  // puts rows back below the fold, which is the bug this is here to kill.
  CF.megaMenuBottomGap = 16;
  CF.megaMenuMinHeight = 120;

  var megaDocumentBound = false;
  var megaReset = null;

  CF.initMegaMenu = function (root) {
    var nav = (root || document).querySelector('#header-nav');
    if (!nav || nav.dataset.cfMegaReady === 'true') return;
    nav.dataset.cfMegaReady = 'true';

    // Drawer width, touch and stylus all keep the native click-to-open.
    var desktop = window.matchMedia('(min-width: 1101px) and (hover: hover) and (pointer: fine)');
    // Sizing is a width question only: a touch laptop opens panels by click
    // but still needs them to fit.
    var wide = window.matchMedia('(min-width: 1101px)');

    var openTimer = null;
    var closeTimer = null;
    var sizeFrame = 0;

    function panels() {
      return nav.querySelectorAll('li.nav-parent-list-item > details');
    }

    /* FB10: how much room is left under the bar, handed to custom.css as
       --cf-mega-max-h. Only measuring can know it: the bar is sticky under a
       header that is itself under an announcement bar, so the gap above it
       shrinks as the page scrolls and no calc() sees both states. */
    function sizePanels() {
      sizeFrame = 0;
      if (!wide.matches) return;

      var room = window.innerHeight - nav.getBoundingClientRect().bottom - CF.megaMenuBottomGap;
      nav.style.setProperty('--cf-mega-max-h', Math.max(room, CF.megaMenuMinHeight) + 'px');
    }

    function queueSize() {
      if (!sizeFrame) sizeFrame = window.requestAnimationFrame(sizePanels);
    }

    function cancel() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    }

    function closeAll(except) {
      panels().forEach(function (detail) {
        if (detail !== except && detail.open) detail.open = false;
      });
    }

    // The single door in. Siblings close before the new panel opens.
    function openOnly(detail) {
      closeAll(detail);
      if (detail && !detail.open) detail.open = true;
    }

    function scheduleOpen(detail) {
      cancel();
      // Once a panel is up, sliding along the bar should feel instant; the
      // delay is only there so a pointer crossing the bar cannot fire one.
      var delay = nav.querySelector('details[open]') ? 0 : CF.megaMenuOpenDelay;
      openTimer = window.setTimeout(function () { openOnly(detail); }, delay);
    }

    nav.querySelectorAll('li.nav-parent-list-item').forEach(function (item) {
      var detail = item.querySelector(':scope > details');

      item.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        if (detail) {
          scheduleOpen(detail);
        } else {
          cancel();
          closeAll();
        }
      });

      if (!detail) return;

      // Every way in ends here — hover, click, keyboard, or theme.js — so the
      // panel is measured once, before the browser paints it.
      detail.addEventListener('toggle', function () {
        if (detail.open) sizePanels();
      });

      var summary = detail.querySelector(':scope > summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        if (!desktop.matches) return;
        event.preventDefault();
        cancel();

        // event.detail is 0 only when the click came from Enter/Space, where
        // there is no hover to have opened the panel already, so that one still
        // toggles. A pointer click always opens: hover may or may not have won
        // the race to open it first, and a toggle would mean the same gesture
        // opens or closes depending on how long the pointer lingered.
        if (event.detail === 0 && detail.open) closeAll();
        else openOnly(detail);
      });
    });

    // The panel is a descendant of <nav>, so moving down into it never leaves.
    nav.addEventListener('mouseleave', function () {
      if (!desktop.matches) return;
      cancel();
      closeTimer = window.setTimeout(function () { closeAll(); }, CF.megaMenuCloseDelay);
    });

    nav.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    });

    // Tabbing out closes it. Deferred, and skipped while the pointer is still
    // in the menu, so the focus shift a click causes cannot close the panel
    // that same click is about to open.
    nav.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!desktop.matches) return;
        if (nav.contains(document.activeElement)) return;
        if (nav.matches(':hover')) return;
        closeAll();
      }, 0);
    });

    // Scrolling slides the announcement bar out from above the header, so the
    // room under the bar grows while a panel is open; a resize changes it too.
    function onViewportChange() {
      if (!nav.querySelector('details[open]')) return;
      queueSize();
    }

    window.addEventListener('scroll', onViewportChange, { passive: true });
    window.addEventListener('resize', onViewportChange, { passive: true });

    function reset() {
      cancel();
      closeAll();
    }

    megaReset = reset;

    if (desktop.addEventListener) desktop.addEventListener('change', reset);
    else if (desktop.addListener) desktop.addListener(reset);

    // Clicking the page behind the menu dismisses it — the scrim is inert on
    // its own, and <details> has no idea the rest of the page exists.
    if (!megaDocumentBound) {
      megaDocumentBound = true;
      document.addEventListener('click', function (event) {
        var current = document.getElementById('header-nav');
        if (!current || current.contains(event.target)) return;
        if (megaReset) megaReset();
      });
    }
  };

  // The drawer head lives in the nav section, which cannot read the header
  // section's logo setting, so it copies whatever logo the header rendered.
  CF.initDrawerLogo = function () {
    var source = document.querySelector('header #logo a');
    var target = document.querySelector('#header-nav .cf-drawer-logo');
    if (source && target) target.innerHTML = source.innerHTML;
  };

  function init() {
    CF.initMarquees();
    CF.initAddToCart();
    CF.initCarousels();
    CF.initSortForms();
    CF.initFilterDrawer();
    CF.initRecentlyViewed();
    CF.initRecommendations();
    CF.initProductGallery();
    CF.initStickyOffset();
    CF.initBuyBox();
    CF.initMegaMenu();
    CF.initDrawerLogo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    CF.initMarquees(event.target);
    CF.initAddToCart(event.target);
    CF.initCarousels(event.target);
    CF.initSortForms(event.target);
    CF.initFilterDrawer(event.target);
    CF.initRecentlyViewed(event.target);
    CF.initRecommendations(event.target);
    CF.initProductGallery(event.target);
    CF.initStickyOffset();
    CF.initBuyBox(event.target);
    CF.initMegaMenu(event.target);
    CF.initDrawerLogo();
  });
})(window.CF);
